export type Skill = { value: string; label: string };

export type SkillCategory = {
  value: string;
  label: string;
  skills: Skill[];
};

export const SKILL_CATEGORIES: SkillCategory[] = [
  {
    value: 'specialist-care',
    label: 'Specialist Care',
    skills: [
      { value: 'early-stage-dementia', label: 'Early stage dementia' },
      { value: 'late-stage-dementia', label: 'Late stage dementia' },
      { value: 'alzheimers', label: "Alzheimer's" },
      { value: 'lewy-bodies', label: 'Lewy Bodies' },
      { value: 'dysphagia', label: 'Dysphagia' },
      { value: 'copd', label: 'COPD' },
      { value: 'multiple-sclerosis', label: 'Multiple Sclerosis' },
      { value: 'parkinsons', label: "Parkinson's" },
      { value: 'visual-hearing-impairments', label: 'Visual & hearing impairments' },
      { value: 'motor-neurone-disease', label: 'Motor Neurone Disease' },
      { value: 'stroke-tia', label: 'Stroke/TIA' },
      { value: 'diabetes', label: 'Diabetes' },
      { value: 'incontinence', label: 'Incontinence' },
      { value: 'arthritis', label: 'Arthritis' },
      { value: 'chronic-pain', label: 'Chronic pain' },
      { value: 'cancer', label: 'Cancer' },
      { value: 'palliative-care', label: 'Palliative care' },
      { value: 'end-of-life-care', label: 'End of life care' },
      { value: 'huntingdons-disease', label: "Huntingdon's disease" },
      { value: 'catheter-care', label: 'Catheter care' },
      { value: 'hoisting', label: 'Hoisting' },
      { value: 'moving-handling', label: 'Moving & handling' },
      { value: 'peg-feeding', label: 'PEG feeding' },
      { value: 'pressure-sores', label: 'Pressure sores' },
    ],
  },
  {
    value: 'personal-care',
    label: 'Personal Care',
    skills: [
      { value: 'toileting-continence', label: 'Toileting & continence' },
      { value: 'dressing', label: 'Dressing' },
      { value: 'medication-prompting', label: 'Medication prompting' },
      { value: 'skincare', label: 'Skincare' },
      { value: 'oral-hygiene', label: 'Oral hygiene' },
      { value: 'bathing', label: 'Bathing' },
      { value: 'shaving', label: 'Shaving' },
      { value: 'haircare', label: 'Haircare' },
      { value: 'mobility-support', label: 'Mobility support' },
      { value: 'eating-drinking-help', label: 'Eating & drinking help' },
    ],
  },
  {
    value: 'companionship',
    label: 'Companionship',
    skills: [
      { value: 'exercise', label: 'Exercise' },
      { value: 'hobby-support', label: 'Hobby support' },
      { value: 'outings', label: 'Outings' },
      { value: 'appointments', label: 'Appointments' },
    ],
  },
  {
    value: 'household',
    label: 'Household',
    skills: [
      { value: 'pet-care', label: 'Pet care' },
      { value: 'cleaning', label: 'Cleaning' },
      { value: 'gardening', label: 'Gardening' },
      { value: 'laundry', label: 'Laundry' },
      { value: 'admin', label: 'Admin' },
      { value: 'meal-prep', label: 'Meal prep' },
      { value: 'shopping', label: 'Shopping' },
      { value: 'prescription-collection', label: 'Prescription collection' },
    ],
  },
];

export const CARE_TYPE_OPTIONS: Skill[] = SKILL_CATEGORIES.map((cat) => ({
  value: cat.value,
  label: cat.label,
}));

export const ALL_SKILLS: Skill[] = SKILL_CATEGORIES.flatMap((cat) => cat.skills);

export function getSkillLabel(value: string): string {
  return ALL_SKILLS.find((s) => s.value === value)?.label ?? value;
}

export function getCategoryLabel(value: string): string {
  return SKILL_CATEGORIES.find((c) => c.value === value)?.label ?? value;
}

export function getCategoryForSkill(skillValue: string): SkillCategory | undefined {
  return SKILL_CATEGORIES.find((cat) => cat.skills.some((s) => s.value === skillValue));
}

/** Groups an array of skill values by their parent category */
export function groupSkillsByCategory(skillValues: string[]): { category: SkillCategory; skills: Skill[] }[] {
  return SKILL_CATEGORIES.map((cat) => ({
    category: cat,
    skills: cat.skills.filter((s) => skillValues.includes(s.value)),
  })).filter((group) => group.skills.length > 0);
}
